<script lang="ts">
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Helpers
	import { time_dots } from '../../../DevicesSettings/Schedules/SchedulesHelpers/schedules';
	import { isValidURL } from '../../../../helpers/utilities';
	//Components
	import DoubleTimePicker from '../../../TimePicker/DoubleTimePicker.svelte';
	//Design system components
	import { IconButton, Text, Input, Container } from '@Shelly/shelly-design-system';

	export let list,
		text,
		message,
		showURLError = false;

	const errorText = $format('enter_valid_url', {
		default: 'Invalid URLs: Please enter a valid URL!',
	});

	const dispatcher = createEventDispatcher();

	list.forEach((action) => {
		let tmpTime = action.int;
		if (tmpTime === '') {
			action.int = ['00:00', '00:00'];
		} else if (typeof tmpTime === 'string') {
			let begin = time_dots(tmpTime.split('-')[0]);
			let end = time_dots(tmpTime.split('-')[1]);

			action.int = [begin, end];
		}
	});

	const handleChange = (url, i) => {
		list[i].url = url;
		dispatcher('newActionChange', list);
	};

	const handleTimeChange = (e, i) => {
		list[i].int = e.detail;
		dispatcher('newActionChange', list);
	};
</script>

{#if list.length > 0}
	<Text element="h2" class="mb-s mt-m">
		{message}
	</Text>
	{#each list as item, i}
		<div class="d-flex mb-m">
			<Input
				aria-label={$format('input_component_webhook_url', {
					default: 'Input webhook URL',
				})}
				bind:value={item.url}
				type="text"
				size="m"
				icon="fas fa-link"
				error={showURLError && !isValidURL(item) ? errorText : ''}
				on:change={() => handleChange(item.url, i)}
				on:input={() => {
					showURLError = false;
				}}
				id="input-yh9v9bf"
			/>
			<IconButton
				aria-label={$format('button_delete_webhook', {
					default: 'Button delete webhook',
				})}
				class="ml-s"
				icon="fas fa-trash"
				variant="danger"
				on:click={() => dispatcher('delete', i)}
			/>
		</div>
		<DoubleTimePicker class="mb-m" time={item.int} on:change={(e) => handleTimeChange(e, i)} />
	{/each}
{:else}
	<Text element="h3" class="mb-s mt-m">
		{text}
	</Text>
{/if}
